module.exports = __webpack_public_path__ + "img/warning_nh3.32972e4b.svg";